__turbopack_context__.v({
  "adornment": "PlanSelector-module__X6nmGW__adornment",
  "codeWrapper": "PlanSelector-module__X6nmGW__codeWrapper",
  "discountIcon": "PlanSelector-module__X6nmGW__discountIcon",
  "main": "PlanSelector-module__X6nmGW__main",
  "plans": "PlanSelector-module__X6nmGW__plans",
  "skeleton": "PlanSelector-module__X6nmGW__skeleton",
  "textfield": "PlanSelector-module__X6nmGW__textfield",
});
